import { ReactNode } from 'react';
import React from 'react';
import { Hidden, makeStyles, Theme } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

// TODO invistigate - mui props not work correctly
const useStyles = makeStyles<Theme, Props>((theme) => ({
  root: {
    width: '100%',
    [theme.breakpoints.only('xs')]: {
      position: (props: Props) => (props.fixedOnly.includes('xs') ? 'fixed' : 'inherit')
    },
    [theme.breakpoints.only('sm')]: {
      position: (props: Props) => (props.fixedOnly.includes('sm') ? 'fixed' : 'inherit')
    },
    bottom: '0px',
    left: '0px',
    margin: '1px',
    zIndex: 1
  }
}));
type Props = {
  children: ReactNode;
  fixedOnly?: Breakpoint[];
};
export const FixedBottomContainer = (props: Props) => {
  const classes = useStyles(props);
  return (
    <>
      <div className={classes.root}>{props.children}</div>
    </>
  );
};
